import React, { useState } from "react";
//css
import "./Login.css";
//components
import ProspectForm from "../../ui/ProspectForm/ProspectForm";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { mainViewState, onFormDirty, onProspectAttachment, onProspectBusinessProprietorFormDirty, onProspectCountryCodes, onProspectDataChange, onProspectFormDirty, onProspectIndexChange, onProspectIsEditing, onProspectKnobValue, onProspectSupplierFormDirty } from "../../redux/main-view";
import { unSavedProspectSendEmail } from "../../services/prospect";
import CustomConfirmDialog from "../../ui/CustomConfirmDialog/CustomConfirmDialog";
import { BsCheckLg } from "react-icons/bs";

const RegisterNow = () => {
    const [isOpeneing, setIsOpeneing] = useState(false);

   //Dispatch
   const dispatch = useDispatch();
   const history = useHistory();

    const { screens } = useSelector(mainViewState);

    // Handle "Back to Login" click
    const handleBackToLogin = async (event) => {
        if (screens.prospect.data.step <= 5) {
            event.preventDefault(); // Prevent immediate navigation
            setIsOpeneing(true);
        }
    };

    const confirmHandler = () => {
        dispatch(onProspectIndexChange(0));
        dispatch(onProspectKnobValue(0));
        dispatch(onProspectDataChange(null));
        dispatch(onProspectAttachment(null));
        dispatch(onProspectIsEditing(false));
        dispatch(onProspectFormDirty(false));
        dispatch(onProspectBusinessProprietorFormDirty(false));
        dispatch(onProspectSupplierFormDirty(false));
        dispatch(onProspectCountryCodes(null));
        dispatch(onFormDirty(false));
        history.push("/prospectindex");
        if (screens.prospect.data) {
            if (!screens.prospect.isEditing && screens.prospect.data.step <= 5) {
                let payload = {
                    id: screens.prospect.data.id,
                };
                unSavedProspectSendEmail(payload);
            }
        }
    };

    return (
        <div className="become_partner RegisterNow">
            <div class="pt-4" style={{ width: "fit-content" }}>
                {/* <div className="md:col-3 col-6"> */}
                <div className="ml-3">
                    <Link to="/login" onClick={handleBackToLogin}>
                        <div className="effect_hover">
                            <span className="back_login flex flex-row align-items-center">
                                <i className="text-2xl pi pi-arrow-circle-left mr-2"></i>
                                <h3> Back to Login</h3>
                            </span>
                        </div>
                    </Link>
                </div>
            </div>
            {/* 
            </div>
        */}
            <div className="grid">
                {/* </div> */}
                <div className="md:col-1"></div>
                <div className="col-12 md:col-10">
                    <div className="mt-2">
                        <ProspectForm />
                    </div>
                </div>
                <div className="md:col-1"></div>
            </div>

            {isOpeneing && (
                <CustomConfirmDialog
                    header="Unsaved Data"
                    type="error"
                    onHide={() => setIsOpeneing(false)}
                    handler={confirmHandler}
                    icon={<BsCheckLg />}
                    title={"Confirm"}
                    firsttext="Are you sure, you want to close the form without saving the changes?"
                    // secondtext="This action cannot be reverted."
                />
            )}
        </div>
    );
};

export default RegisterNow;
